<div class="panel panel-default">
  <div class="panel-heading">
    <h2 class="panel-title">{{ 'events.search.component.title' | translate }}</h2>
  </div>
  <div class="panel-body">
    <div *ngIf="isSearching" class="row">
      <wl-busy [show]="isSearching"></wl-busy>
    </div>
    <div class="row">
      <form>
        <input type="text" placeholder="{{ 'events.search.component.keyword-placeholder' | translate }}"
          [(ngModel)]="searchParams.Keyword" />
        <input type="date" [(ngModel)]="searchParams.SearchDateBegin" />
        <input type="date" [(ngModel)]="searchParams.SearchDateEnd" />

        <label class="checkbox-inline">
          <input type="checkbox" [checked]="searchParams.OrganizationEvent" />
          {{ 'events.search.component.restrict-to-organization-label' | translate }}
        </label>
        <label class="checkbox-inline">
          <input type="checkbox" [checked]="searchParams.CommunityEvent" />
          {{ 'events.search.component.restrict-to-community-label' | translate }}
        </label>
        <label class="checkbox-inline">
          <input type="checkbox" [checked]="searchParams.MembersOnlyEvent" />
          {{ 'events.search.component.restrict-to-members-only-label' | translate }}
        </label>
        <label class="checkbox-inline">
          <input type="checkbox" [checked]="searchParams.InternalEvent" />
          {{ 'events.search.component.restrict-to-internal-label' | translate }}
        </label>
        <button pButton type="button" (click)="loadEvents($event)">{{ 'events.search.component.search-button' | translate
          }}</button>
      </form>
      <p-table [showGridlines]="true" #searchEventsDataGrid [value]="upcomingEvents.Result" [rows]="searchParams.PageSize" [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[5, 10, 20]" [lazy]="true" [totalRecords]="upcomingEvents.TotalCount">
        <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
          <SortAltIcon *ngIf="sortOrder === 0">
            <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
          </SortAltIcon>
          <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
            <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
          </SortAmountUpAltIcon>
          <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
            <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
          </SortAmountDownIcon>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th [pSortableColumn]="'EventName'">
              {{ 'events.search.component.event-name-header' | translate }}
              <p-sortIcon></p-sortIcon>
            </th>
            <th [pSortableColumn]="'StartDate'">
              {{ 'events.search.component.event-date-header' | translate }}
              <p-sortIcon></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-event>
          <tr>
            <td>
              <a href="/events/detail/{{ event.EventId }}">{{ event.EventName }}</a>
            </td>
            <td>{{ event.StartDate | date: 'MM/dd/yyyy' }}</td>
          </tr>
        </ng-template>
      </p-table>
<p-progressSpinner *ngIf="isSearching"></p-progressSpinner>
    </div>
  </div>
</div>